import { render, staticRenderFns } from "./EmergencyAccess.vue?vue&type=template&id=39493544&scoped=true&"
import script from "./EmergencyAccess.vue?vue&type=script&lang=js&"
export * from "./EmergencyAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39493544",
  null
  
)

export default component.exports